import { useContext } from "react";
import { PermissionsContext } from "contexts/PermissionsContext";

// ==============================|| CONFIG - HOOKS  ||============================== //

const usePermissions = () => useContext(PermissionsContext);

export default usePermissions;
